export type SideCoverProps = {
  // page type to show which background content
  pageType: PageType;
  // TODO: rename this prop
  noticeList?: NoticeType[];
  // footer text
  footerText?: string;
  // background image url
  backgroundImage?: string;
  // TODO: remove this prop
  copyRight?: string;
  // side cover left (width 70% in web view)
  isCoverLeft?: boolean;
};

export enum PageType {
  MAIN = 'main',
  SIGN_UP = 'signup',
  SUCCESS = 'success',
}

export type NoticeType = {
  description: string;
  position?: string;
  name?: string;
  avatarUrl?: string;
};
